import type {
  DialogDisclosureHTMLProps,
  DialogDisclosureOptions,
  DialogDisclosureProps,
} from "reakit";
import { useDialogDisclosure } from "reakit";
import { createComponent, createHook } from "reakit-system";

export type ModalDisclosureProps = DialogDisclosureProps;

/**
 * @public
 * aria-haspopup и aria-expanded сделаны undefined
 * @see https://github.com/ariakit/ariakit/issues/925
 *
 */
export const useModalDisclosure = createHook<DialogDisclosureOptions, DialogDisclosureHTMLProps>({
  compose: [useDialogDisclosure],
  useProps(options, props) {
    return {
      ...props,
      "aria-expanded": undefined,
      "aria-haspopup": undefined,
    };
  },
});
export const ModalDisclosure = createComponent<"button", DialogDisclosureOptions>({
  as: "button",
  useHook: useModalDisclosure,
});
